export function checkTransitionsAndActions (tempConfigFile, assetID) {
  return new Promise((resolve, reject) => {
    const actionsAffected = tempConfigFile.actions.filter(
      action => action.assetType === assetID
    );
    const transitionsAffected = [];

    tempConfigFile.transitions.forEach(transition => {
      if (
        transition.actions.filter(action => action.assetType === assetID).length
      ) { transitionsAffected.push(transition); }
    });

    resolve({
      assetID: assetID,
      actionsAffected: actionsAffected,
      transitionsAffected: transitionsAffected
    });
  });
}

export function deleteAssetsProcess (tempConfigFile, affectedDependencies) {
  return new Promise((resolve, reject) => {
    const newTempConfigFile = tempConfigFile;

    affectedDependencies.actionsAffected.forEach(element => {
      newTempConfigFile.actions.splice(
        newTempConfigFile.actions.findIndex(item => item.id === element.id),
        1
      );
    });

    affectedDependencies.transitionsAffected.forEach(element => {
      newTempConfigFile.transitions.splice(
        newTempConfigFile.transitions.findIndex(item => item.id === element.id),
        1
      );
    });

    newTempConfigFile.assetTypes.splice(
      newTempConfigFile.assetTypes.findIndex(
        item => item.id === affectedDependencies.assetID
      ),
      1
    );

    resolve({ ...newTempConfigFile });
  });
}
